import { useContext, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import core, { API, App } from '@gin-betting/core';
import filters from '@gin-betting/filters';

import { BettingWidgets } from 'app-constants';
import { useAppliedFilters, useWidgetSettings } from 'hooks';
import ui from 'modules/ui';
import { State } from 'types';
import { OverlayType } from '../../../constants';
import { useOutrightsCountBySport } from '../../../hooks';
import { getSortedCategorizerItems } from '../../../utils';
import { MobileFiltersCtx } from '../MobileFiltersCtx';

const {
    selectors: { selectCategorizerData },
} = filters;
const {
    entities: {
        selectors: { selectSports },
    },
    utils: { getSportTypeFromLocation, checkOnRoute },
} = core;
const {
    actions: { setActiveMobileCountryKey },
} = ui;

interface Output {
    categorizerItems: API.CategorizerItem[];
    handleLinkClick: VoidFn;
    sportId?: string;
}

const selectProps = (state: State) => {
    const sports = selectSports(state);
    const categorizerItems = selectCategorizerData(state);

    return { sports, categorizerItems };
};

function useSportsList(): Output {
    const dispatch = useDispatch();
    const { setOverlay } = useContext(MobileFiltersCtx);
    const { sportId } = useAppliedFilters();

    const {
        categorizerItems: outrightCategorizerItems,
    } = useOutrightsCountBySport();

    const sportType = getSportTypeFromLocation();

    const { sportsOrder } = useWidgetSettings({
        widget: BettingWidgets.CATEGORIZER,
    });

    const { sports, categorizerItems } = useSelector((state: State) =>
        selectProps(state)
    );

    const sortedCategorizerItems = useMemo(
        () =>
            getSortedCategorizerItems({
                sportType,
                sports,
                sportsOrder,
                categorizerItems,
                outrightCategorizerItems,
            }),
        [
            sportType,
            sports,
            categorizerItems,
            outrightCategorizerItems,
            sportsOrder,
        ]
    );

    const handleLinkClick = () => {
        dispatch(setActiveMobileCountryKey(''));

        if (!checkOnRoute(App.Routes.RESULTS_LIST)) return;

        setOverlay(OverlayType.TOURNAMENT_LIST);
    };

    return {
        sportId,
        handleLinkClick,
        categorizerItems: sortedCategorizerItems,
    };
}

export default useSportsList;
